export enum ErichRoles
{

    Administrator = "Administrator",
}